import ModalViewModel, {
  ModalViewModelClosingSignal,
} from 'infra/ModalViewModel'
import { computed, makeObservable } from 'mobx'
import User from 'iam/models/User'
import { NewUserTransactionViewModel } from './NewUserTransactionViewModel'
import { Subject, race, firstValueFrom } from 'rxjs'
import { map } from 'rxjs/operators'

/**
 * Confirmation for creating high value transactions.
 */
export class ConfirmUserTransactionViewModel extends ModalViewModel {
  /**
   * Confirmations.
   */
  private readonly _confirm = new Subject()

  /**
   * Constructor.
   */
  constructor(
    readonly editor: NewUserTransactionViewModel,
    closingSignal: ModalViewModelClosingSignal,
  ) {
    super(closingSignal)
    makeObservable(this)
  }

  /**
   * The amount.
   */
  @computed
  get amount() {
    return this.editor.amount
  }

  /**
   * The recipient.
   */
  @computed
  get recipient() {
    return this.editor.selectedMember?.user ?? User.none
  }

  /**
   * The reason.
   */
  @computed
  get reason() {
    return this.editor.reason
  }

  /**
   * Requests confirmation.
   */
  requestConfirmation = () => {
    const promise = firstValueFrom(
      race(
        this.close$.pipe(map(() => false)),
        this._confirm.pipe(map(() => true)),
      ),
      {
        defaultValue: false,
      },
    )
    this.show()
    return promise
  }

  /**
   * Confirm.
   */
  confirm = () => {
    this._confirm.next(undefined)
    this.close()
  }
}
